import { AuthRole, AuthTokenTimestamp } from "@/utils/auth-valid.util";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { AcceptorRoutes } from "./routes/acceptor.route";
import { AdminRoutes } from './routes/admin.route';
import { CommonRoutes } from './routes/common.route';
import { ClientRoutes } from './routes/client.route';
import { RoleAllowedToRoute, AllowedToRoute, AcceptorRoute } from "./routes/guard-route";
import { OpenRoutes } from "./routes/open.route";

const routes: Array<RouteRecordRaw> = [
  ...OpenRoutes,
  CommonRoutes,
  AdminRoutes,
  ClientRoutes,
  AcceptorRoutes,
];
const router = createRouter({
  history: createWebHistory('/'),
  routes,
});
router.beforeEach(async (to, from, next) => {
  document.title =
    to.meta.title && typeof to.meta.title === 'string'
      ? to.meta.title
      : 'Creative Contracts';
  const isOpen = to.name && AllowedToRoute(to.name.toString());
  if (isOpen) {
    next();
  } else {
    const isAcceptorRoute = to.name != undefined && AcceptorRoute(to.name.toString()) === true;
    const canAccess = AuthTokenTimestamp(isAcceptorRoute) || true;
    const role = AuthRole(isAcceptorRoute);
    if (!canAccess && to.name !== 'login') {
      next({
        name: 'login'
      });
    } else if (to.name && RoleAllowedToRoute(role, to.name.toString())) {
      next();
    } else {
      next({
        name: '404'
      });
    }
  }
});
export default router;
